import { Portal, TooltipContentProps } from '@radix-ui/react-tooltip';
import { forwardRef } from 'react';

import { OmitStrict } from '../../types';

import { TooltipArrow, TooltipContent } from './Tooltip.styled';
import { TooltipProps } from './types';

type Props = OmitStrict<TooltipContentProps, 'content'> &
  Pick<TooltipProps, 'content'>;

const PortalTooltipContent = forwardRef<HTMLDivElement, Props>(
  ({ children, content, ...rest }, ref) => (
    <Portal>
      <TooltipContent ref={ref} {...rest}>
        {content === undefined ? children : content}
        <TooltipArrow />
      </TooltipContent>
    </Portal>
  ),
);

export default PortalTooltipContent;
